import React, { Component } from "react";
import Left from "views/stepPortal/login/components/Left";
import Right from "views/stepPortal/login/components/Right";
import "views/stepPortal/scss/Index.scss";
class MainLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div className="flex">
        <div className="w-1/2">
          <Left />
        </div>

        <div className="w-1/2">
          <Right />
        </div>
      </div>
    );
  }
}
export default MainLogin;
